import { render, staticRenderFns } from "./case-detail-konwlege.vue?vue&type=template&id=b475abea&scoped=true&"
import script from "./case-detail-konwlege.vue?vue&type=script&lang=js&"
export * from "./case-detail-konwlege.vue?vue&type=script&lang=js&"
import style0 from "./case-detail-konwlege.vue?vue&type=style&index=0&id=b475abea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b475abea",
  null
  
)

export default component.exports